import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, Clock, LogOut, Mail } from "lucide-react";

import { useAuth } from "@/hooks/useAuth";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";

export default function Onboarding() {
  const navigate = useNavigate();
  const { user, loading: authLoading, signOut } = useAuth();

  const handleSignOut = async () => {
    await signOut();
    navigate("/auth");
  };

  useEffect(() => {
    if (!authLoading && !user) {
      navigate("/auth");
    }
  }, [user, authLoading, navigate]);

  if (authLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <Loader2 className="h-8 w-8 animate-spin text-brand" />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background flex flex-col">
      <header className="border-b border-border bg-card">
        <div className="container mx-auto px-4 py-4 flex items-center justify-between">
          <img src="/logo-altus.png" alt="Altus Food" className="h-10 w-auto" />
          <div className="flex items-center gap-3">
            {user?.email && (
              <span className="text-sm text-muted-foreground hidden sm:inline">
                {user.email}
              </span>
            )}
            <Button
              variant="ghost"
              size="sm"
              onClick={handleSignOut}
              className="text-muted-foreground hover:text-foreground"
            >
              <LogOut className="h-4 w-4 mr-2" />
              Sair
            </Button>
          </div>
        </div>
      </header>

      <main className="flex-1 container mx-auto px-4 py-8 max-w-xl flex items-center">
        <Card className="border-border w-full">
          <CardHeader className="text-center">
            <div className="inline-flex items-center justify-center h-16 w-16 rounded-full bg-brand/10 mb-4 mx-auto">
              <Clock className="h-8 w-8 text-brand" />
            </div>
            <CardTitle className="text-2xl">Aguardando Configuração</CardTitle>
            <CardDescription className="mt-2">
              Seu restaurante ainda não foi configurado em nossa plataforma.
            </CardDescription>
          </CardHeader>
          <CardContent className="space-y-6">
            <div className="rounded-lg bg-muted/50 p-4 text-sm text-muted-foreground space-y-2">
              <p>
                O cadastro do seu estabelecimento é realizado pela nossa equipe
                administrativa. Em breve você receberá acesso completo ao sistema.
              </p>
              <p>
                Caso já tenha solicitado a criação, entre em contato com o
                administrador para verificar o status.
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-3">
              <Button
                asChild
                variant="default"
                className="flex-1 bg-brand hover:bg-brand/90"
              >
                <a href="mailto:contato@sejaaltus.com.br">
                  <Mail className="h-4 w-4 mr-2" />
                  Falar com o suporte
                </a>
              </Button>
              <Button
                variant="outline"
                onClick={handleSignOut}
                className="flex-1"
              >
                <LogOut className="h-4 w-4 mr-2" />
                Sair da conta
              </Button>
            </div>
          </CardContent>
        </Card>
      </main>
    </div>
  );
}